import { InputAdornment, TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment'; // Keep moment for your internal _value conversion if preferred, or switch to Dayjs consistently
import { useSelector } from 'react-redux';

const DateField = ({
  disabled,
  value,
  onChange,
  label,
  variant,
  width,
  focused,
  disablePast, // This prop still controls disabling all past dates
  disableFuture,
  error,
  helperText,
  disablePastFromDate, // New prop to disable past from a specific date
}) => {
  const userProfile = useSelector((state) => state.login);

  const _value = value !== null && value !== undefined && value !== '' ? moment(value) : null;

  // Determine the minDate based on disablePast and disablePastFromDate
  let effectiveMinDate = null;
  if (disablePast) {
    effectiveMinDate = moment(); // Disable all past dates from today
  } else if (disablePastFromDate) {
    // If disablePastFromDate is provided, use it.
    // Ensure disablePastFromDate is a valid date string/object that moment can parse.
    effectiveMinDate = moment(disablePastFromDate);
  }

  // Ensure effectiveMinDate is a Dayjs object for the DatePicker
  const finalMinDate = effectiveMinDate;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={userProfile.user.country === 'India' ? 'en-gb' : 'en'}
    >
      <DatePicker
        value={_value}
        onChange={onChange}
        label={label}
        disablePast={disablePast} // This prop will now only control disabling ALL past dates if true
        minDate={finalMinDate} // Use the calculated effectiveMinDate here
        size="small"
        fullWidth
        variant={variant}
        disabled={disabled}
        InputProps={{
          startAdornment: <InputAdornment position="start" />,
          readOnly: true,
        }}
        maxDate={disableFuture ? moment() : null} // Use moment() for current date for maxDate
        InputLabelProps={{ style: { marginLeft: '10px' } }}
        renderInput={(props) => (
          <TextField
            {...props}
            sx={{ width: width, mb: '8px', my: '10px' }}
            size="small"
            focused={focused}
            variant={variant}
            error={error}
            helperText={helperText}
            disabled={disabled}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DateField;
